var map = {
	"./de/general13/slide1.svg": 280221,
	"./en/general13/slide1.svg": 490193,
	"./es/general13/slide1.svg": 287582,
	"./fr/general13/slide1.svg": 348518,
	"./nl/general13/slide1.svg": 677352,
	"./pt/general13/slide1.svg": 632890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183989;